import { app } from '../../App';
import { Effect, EffectParams } from './Effect';
import { EffectStack, EffectStackParams, EffectStackStateValues } from './EffectStack';

export type EffectFunc = (effectFunctionParams: EffectFuncParams, effectParams: EffectParams, onComplete: () => void) => void;

export interface EffectFuncParams {
  [index: string]: any;
}

// export interface Effect {
//   target: Phaser.GameObjects.Image[];
//   delay: number;
//   startX: number;
//   startY: number;
//   endX: number;
//   endY: number;
// }

// export interface EffectStack {
//   state: EffectStackStateValues;
//   targets: Effect[];
//   endPoints: number[][];
//   showEffect: (effect: EffectParams, onComplete: () => void) => void;
//   ongoingEffect?: (effect: EffectParams, onComplete: () => void) => void;
//   hideEffect: (effect: EffectParams, onComplete: () => void) => void;
//   [index: string]: any;
// }

export class EffectsLayer {
  protected scene: Phaser.Scene;
  protected effectsLayer: Phaser.GameObjects.Layer;
  protected effectStacks: EffectStack[];

  protected freePool: Set<Effect>;
  protected livePool: Set<Effect>;

  constructor(scene: Phaser.Scene, effectsLayer: Phaser.GameObjects.Layer) {
    this.scene = scene;
    this.effectsLayer = effectsLayer;

    this.effectStacks = [];

    this.freePool = new Set();
    this.livePool = new Set();

    this.scene.events.once(Phaser.Scenes.Events.SHUTDOWN, this.shutdown, this);
  }

  public getFreeEffect(startX: number, startY: number, key: string, frame: string): Effect {
    console.log(this.freePool);
    if (this.freePool.size <= 0) {
      let effect = this.makeEffect(startX, startY, key, frame);
      console.log(this.livePool);
      this.livePool.add(effect);
      return effect;
    } else {
      let effect: Effect = this.freePool.values().next().value;
      effect.x = startX;
      effect.y = startY;
      effect.setTexture(key, frame);

      return effect;
    }
  }

  // public showEffect(effect: Effect, index: number, effectStack: EffectStack) {
  //   this.effectsLayer.add(effect);
  //   effectStack.showEffect({
  //     target: effect,
  //     endX: effectStack.endPoints[index][0],
  //     endY: effectStack.endPoints[index][1]
  //   });
  // }

  public showEffectStack(stackParams: EffectStackParams) {
    let stack = new EffectStack(stackParams);
    this.effectStacks.push(stack);

    stack.showEffects(this);
  }

  public clearAll() {
    // this.effectsLayer.removeAll();
  }

  public makeSplat(splatBank: string[]) {}

  // public throwEffectWrapper(effectParam: EffectParam) {
  //   return this.throwEffect;
  // }

  public throwEffect(funcParams: EffectFuncParams, effectParams: EffectParams, onComplete: () => void) {
    let startX = effectParams.target.x;
    let startY = effectParams.target.y;
    let baseDelay: number = effectParams.baseDelay ?? 0;
    let baseDuration: number = (effectParams.baseDuration ?? 0) + Phaser.Math.Between(0, 100);

    effectParams.target.scale = 0.25;
    this.scene.add.tween({
      targets: effectParams.target,
      x: effectParams.endX,
      scaleX: 1,
      scaleY: 1,
      duration: baseDuration,
      ease: Phaser.Math.Easing.Cubic.In,
      delay: baseDelay
    });

    this.scene.add.tween({
      targets: effectParams.target,
      y: startY - 300,
      duration: baseDuration * 0.5,
      ease: Phaser.Math.Easing.Cubic.Out,
      delay: baseDelay
    });

    this.scene.add.tween({
      targets: effectParams.target,
      y: effectParams.endY,
      duration: baseDuration * 0.5,
      ease: Phaser.Math.Easing.Cubic.In,
      delay: baseDelay + baseDuration * 0.5,
      onComplete: () => {
        if (funcParams.sound) app.audioHandler.playSound(this.scene, funcParams.sound, 'sfx');
        onComplete();
      }
    });
  }

  public slideEffect(funcParams: EffectFuncParams, effectParam: EffectParams, onComplete: () => void) {
    let slideDuration = funcParams.duration ?? 5000;

    this.scene.add.tween({
      targets: effectParam.target,
      y: effectParam.target.y + Phaser.Math.Between(50, 100),
      duration: slideDuration,
      ease: Phaser.Math.Easing.Linear,
      onComplete: onComplete
    });
  }

  public fadeInEffect(funcParams: EffectFuncParams, effectParam: EffectParams, onComplete: () => void) {
    let delay = funcParams.delay ?? 0;
    effectParam.target.alpha = 0;
    this.scene.add.tween({
      targets: effectParam.target,
      alpha: 1,
      duration: 1000,
      ease: Phaser.Math.Easing.Sine,
      delay: delay,
      onComplete: onComplete
    });
  }

  public fadeOutEffect(funcParams: EffectFuncParams, effectParam: EffectParams, onComplete: () => void) {
    let delay = funcParams.delay ?? 0;
    console.log("Fade out ", funcParams);
    this.scene.add.tween({
      targets: effectParam.target,
      alpha: 0,
      duration: 1000,
      ease: Phaser.Math.Easing.Sine,
      delay: delay,
      onComplete: onComplete
    });
  }

  public changeImageEffect(funcParams: EffectFuncParams, effectParam: EffectParams, onComplete: () => void) {
    if (effectParam.targetKey && effectParam.targetFrame) {
      effectParam.target.setTexture(effectParam.targetKey, effectParam.targetFrame);
    }

    onComplete();
  }

  public getBoxPositions(
    boxWidth: number,
    boxHeight: number,
    segmentsWide: number,
    segmentsTall: number,
    excludedArea: Phaser.Geom.Rectangle = new Phaser.Geom.Rectangle(480, 100, 960, 568)
  ): number[] {
    let segmentPool: number[] = Array.from(Array(segmentsWide * segmentsTall).keys());

    let rec = new Phaser.Geom.Rectangle();
    for (let i = 0; i < segmentPool.length; i++) {
      const boxX = (segmentPool[i] % segmentsWide) * boxWidth;
      const boxY = Math.floor(segmentPool[i] / segmentsWide) * boxHeight;
      rec.setTo(boxX, boxY, boxX + boxWidth, boxY + boxHeight);
      Phaser.Geom.Intersects.RectangleToRectangle(excludedArea, rec);
    }

    for (let i = segmentPool.length; i >= 0; i--) {
      const boxX = (segmentPool[i] % segmentsWide) * boxWidth;
      const boxY = Math.floor(segmentPool[i] / segmentsWide) * boxHeight;

      if (
        excludedArea.contains(boxX, boxY) ||
        excludedArea.contains(boxX + boxWidth, boxY) ||
        excludedArea.contains(boxX, boxY + boxHeight) ||
        excludedArea.contains(boxX + boxWidth, boxY + boxHeight)
      ) {
        segmentPool.splice(i, 1);
      }
    }

    console.log('pool', segmentPool);

    return segmentPool;
  }

  public getRandomBoxDistribution(
    offsetX: number,
    offsetY: number,
    width: number,
    height: number,
    segmentsWide: number,
    segmentsTall: number,
    positionsRequired: number,
    excludedArea: Phaser.Geom.Rectangle = new Phaser.Geom.Rectangle(480, 200, 960, 368)
  ) {
    let boxWidth = width / segmentsWide;
    let boxHeight = height / segmentsTall;

    let segmentPool = this.getBoxPositions(boxWidth, boxHeight, segmentsWide, segmentsTall, excludedArea);

    let selectedSegments: number[] = [];
    let positions: number[][] = [];

    for (let i = 0; i < positionsRequired; i++) {
      let rand = Phaser.Math.Between(0, segmentPool.length - 1);
      let box = segmentPool.splice(rand, 1)[0];
      selectedSegments.push(box);

      let boxX = box % segmentsWide;
      let boxY = Math.floor(box / segmentsWide);

      let x = Phaser.Math.Between(boxX * boxWidth, boxX * boxWidth + boxWidth);
      let y = Phaser.Math.Between(boxY * boxHeight, boxY * boxHeight + boxHeight);

      positions.push([offsetX + x, offsetY + y]);
    }

    console.log('selected segments', selectedSegments);

    return positions;
  }

  protected shutdown() {
    this.freePool.clear();
    this.livePool.clear();
    // this.effectsLayer.removeAll();
  }

  protected makeEffect(startX: number, startY: number, key: string, frame: string): Effect {
    let effect = new Effect(this.scene, startX, startY, key, frame);
    effect.scrollFactorX = 0;
    effect.scrollFactorY = 0;
    effect.setActive(false);
    effect.setVisible(false);
    console.log(this.effectsLayer, effect);
    this.effectsLayer.add(effect);

    return effect;
  }
}
